import { render, staticRenderFns } from "./PositiveInfectionsBarChart.vue?vue&type=template&id=7341afa3&"
import script from "./PositiveInfectionsBarChart.vue?vue&type=script&lang=js&"
export * from "./PositiveInfectionsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports